import {combineReducers} from "redux";
import auth from "./auth";
import releaseTicket from "./releaseTicket";

export default combineReducers({ auth, releaseTicket });
